import { RouteItem } from '../../../interfaces/RouteItem';
import { User } from '../../../interfaces/User';
import { SidebarItem } from '../../sidebar/Sidebar';
import { isEnabled } from '../../EnablingFeature';

export const canShow = (
    user: User | null,
    item: RouteItem | SidebarItem
): boolean => {
    return (
        item?.level.includes(user?.user_level || 0) && isEnabled(item?.feature)
    );
};

export const hasPermission = ({
    userPermissions,
    module,
    permissionList,
    feature
}: {
    userPermissions: Record<string, string>;
    module: string;
    permissionList: string[];
    feature?: string;
}): boolean => {
    const modulePermission = userPermissions[module];

    if (module !== 'home' && (!modulePermission || modulePermission === 'none'))
        return false;

    // Allow "Accessible" feature unconditionally
    if (feature === 'Accessible') return true;

    if (modulePermission === '*') return true;

    const grantedPermissions = modulePermission.split(',').map((p) => p.trim());

    return permissionList.some((p) => grantedPermissions.includes(p));
};
